module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-tit"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter1"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Lion Has Wings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 2")]), _vm._v(" The First of the Few")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 3")]), _vm._v(" Angels One Five")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 4")]), _vm._v(" Reach for the Sky")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Battle of Britain")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 6")]), _vm._v(" First Light")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sp_toc"
  }, [_vm._v("Chapter 7")]), _vm._v(" ‘Last Light?’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Other_Books",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Dilip Sarkar")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0